function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_twitter",
  transform: "translate(-1450 -4052)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62_629",
  "data-name": "\\u77E9\\u5F62 629",
  className: "cls-1",
  width: 18,
  height: 18,
  transform: "translate(1450 4052)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_twitter-2",
  "data-name": "icon_twitter",
  d: "M1453.766,3706.119a6.223,6.223,0,0,1-1.768.477,3.047,3.047,0,0,0,1.353-1.676,6.227,6.227,0,0,1-1.954.735,3.1,3.1,0,0,0-2.246-.957,3.054,3.054,0,0,0-3.078,3.029,2.959,2.959,0,0,0,.08.69,8.783,8.783,0,0,1-6.344-3.165,2.983,2.983,0,0,0-.417,1.523,3.017,3.017,0,0,0,1.37,2.521,3.092,3.092,0,0,1-1.394-.379v.038a3.043,3.043,0,0,0,2.468,2.97,3.142,3.142,0,0,1-1.39.052,3.074,3.074,0,0,0,2.875,2.1,6.279,6.279,0,0,1-4.556,1.254,8.81,8.81,0,0,0,4.718,1.361,8.624,8.624,0,0,0,8.755-8.619q0-.2-.009-.392A6.188,6.188,0,0,0,1453.766,3706.119Z",
  transform: "translate(12.734 350.302)"
}));

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.44ae2c92.svg";
export { ForwardRef as ReactComponent };